import { TableBody, TableCell, TableRow } from "@mui/material";
import DynamicTable from "../../../components/tables/dynamicTable";
import { DateProgressBar } from "../../../components/hospitalManagement/dateProgressBar";
import moment, { Moment } from "moment";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import routesName from "../../../constants/routesName";
import { useAppDispatch } from "../../../redux/store";
import { getHospitalById } from "../../../redux/addHospital/hospitalManagementReducer";
import successToast from "../../../utils/successToast";
import errorToast from "../../../utils/errorToast";
import { LoadingSpinner } from "../../../components/ui/loadinSpinner";
import { removeUnderScore } from "../../../helper";
import useDisplayToggle from "../../../utils/useDisplayToggle";
import useAxios from "../../../hooks/useAxios";
import { hospitalApi } from "../../../jsonData/apiPathData/hospital";
import DeleteIcon from "../../../assests/icons/deleteIcon.png";
import ConfirmationModal from "../../../components/modals/confirmationModal";
import { formatIndianRupee } from "../../../utils/formatIndianRupee";
import { ActionTooltip } from "../../../utils/toolTip";
import { AsyncAccessTokenDecoder } from "../../../utils/accessTokenDecoder";
import axios from "axios";
import { Grid } from "@mui/material";
import DataRangeSelector from "../../../components/dataRangeSelector";
import Departments from "../../mis/patientDetails/departments";
import Diagnosis from "../../mis/patientDetails/diagnosis";
import { CustomHeight } from "../../../components/themeProvider";
import InPatientOccupied from "./Patient Type/InPatientOccupied";
import OccpancyCharts from "./occupancyCharts/OccpancyCharts";
import EquipmentDetailsChart from "./occupancyCharts/EquipmentDetailsChart";

const HospitalDashBoardTab = ({ hospitalDetailsRes }: any) => {
  const styles = {
    // borderLeft: "1px solid #F2F4F7",
    borderRight: "1px solid #F2F4F7",
    borderBottom: "1px solid #F2F4F7",
    background: "white",
    minWidth: "150px",
    maxWidth: "150px",
    paddingLeft: "16px",
    paddingRight: "16px",
    color: "#667085",
    fontWeight: 500,
    fontFamily: "Inter, sans-serif",
    height: "70px",
  };
  const currentDate = new Date();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const hospitalId = hospitalDetailsRes?.data?.data?.hospitalId;
  const [productId, setProductId] = useState<number>();
  const [action, setAction] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [clinicalAssitantStatus, setClinicalAssitantStatus] = useState(false);
  const [managmentAssitantStatus, setManagmentAssitantStatus] = useState(false);
  const decodeToken = AsyncAccessTokenDecoder();
  // const currentDate = new Date();
  // const currentYearStart = moment(currentDate).startOf("year");
  // const currentYearEnd = moment(currentDate).endOf("year");
  const currentYearStart = moment(currentDate)
    .subtract(11, "month")
    .subtract(1, "day");
  const currentYearEnd = moment(currentDate);
  const [fromDate, setFromDate] = useState<Moment | null>(currentYearStart);
  const [toDate, setToDate] = useState<Moment | null>(currentYearEnd);
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [taluk, setTaluk] = useState("");
  const [hobli, setHobli] = useState("");
  const [serviceType, setServiceType] = useState<any>("");
  const [filterApplyToggle, setFilterApplyToggle] = useState(false);
  const productAndPlanInfo =
    hospitalDetailsRes?.data?.data?.productandPlanInfos;

  const [moreOption, setMoreOption] = useState<null | number | boolean>(null);
  const [isMoreOption, setisMoreOption] = useState<any>(false);

  const onClickRef = useRef(null);
  const insideClickRef = useRef(null);
  useDisplayToggle({
    onClickRef,
    insideClickRef,
    setDisplay: setisMoreOption,
  });

  useEffect(() => {
    if (isMoreOption === false) {
      setMoreOption(null);
    }
  }, [isMoreOption]);

  const toogle = (index: number) => {
    if (moreOption === index) {
      setisMoreOption(false);
      setMoreOption(null);
    } else {
      setMoreOption(index);
      setisMoreOption(true);
    }
  };
  const editHospitalFn = () => {
    navigate(
      `${routesName.hospitalManagementPage}/edit-product-plan/${hospitalId}`
    );
  };

  // checking for cilincial assistant is active or not
  useEffect(() => {
    const clinicalAssitStatus =
      productAndPlanInfo?.find(
        (item: any) => item?.productInfo?.productId === 1001
      )?.planInfo?.isActive === 1;
    setClinicalAssitantStatus(clinicalAssitStatus);
    const managementAssitStatus =
      productAndPlanInfo?.find(
        (item: any) => item?.productInfo?.productId === 1000
      )?.planInfo?.isActive === 1;
    setManagmentAssitantStatus(managementAssitStatus);
  }, [productAndPlanInfo]);

  const hospitalActiveDeactivateFn = (productId: number, action: string) => {
    if (productId === 1000 && clinicalAssitantStatus) {
      errorToast(
        "You can't deactivate Management Assistant while Clinical Assistant is still active"
      );
    } else if (productId === 1001 && !managmentAssitantStatus) {
      errorToast(
        "You can't activate Clinical Assistant while Management Assistant is deactive"
      );
    } else {
      setProductId(productId);
      setAction(action);
      setIsShowModal(true);
    }
  };
  // activate deactivate product axios call
  const {
    data: activateOrDeactivateSuccess,
    error: activateOrDeactivateError,
    loading: activateOrDeactivateLoading,
    postFn: activateOrDeactivateFn,
    toggle,
  } = useAxios({
    method: "post",
    path: `${hospitalApi.activateOrDeactivate
      }hospitalid=${hospitalId}&productid=${productId}&isactive=${action === "Deactivate" ? 0 : 1
      }`,
  });

  useEffect(() => {
    const handleDeactivation = async () => {
      if (!activateOrDeactivateSuccess?.success) return;

      successToast(activateOrDeactivateSuccess?.message);

      // Only proceed when product is Deactivated
      if (action === "Deactivate") {
        try {
          const loginUrl = process.env.REACT_APP_MA_LOGIN_NEW_URL || "";
          const deactivateUrl = process.env.REACT_APP_MA_DEACTIVATE_HOSPITAL_URL || "";




          // 4. Call the MA deactivate API
          if (hospitalId) {
            const maResponse = await axios.get(deactivateUrl, {
              headers: {
                Authorization: `Bearer ${sessionStorage.getItem("newlogin")}`,
                "Content-Type": "application/json",
              },
              params: { hospitalId },
            });
            if (maResponse) {
              // 1. Get stored MA credentials
              const userString = sessionStorage.getItem("maLoginCredentials");
              const user = userString ? JSON.parse(userString) : null;

              const loginBody = {
                email: user?.email,
                password: user?.password,
              };

              // 2. Login to MA and get new token
              const loginResponse = await axios.post(
                loginUrl,
                loginBody,
                {
                  headers: {
                    "Content-Type": "application/json",
                    accept: "*/*",
                  },
                }
              );

              const accessToken = loginResponse?.data?.access_token;

              // 3. Save new token
              sessionStorage.setItem("newlogin", accessToken);
              window.location.reload();
            }
            console.log("MA API Response:", maResponse.data);
          }
        } catch (err: any) {
          console.error("MA API Error:", err);
          errorToast("MA Assistant API failed");
        }
      }

      // 5. Refresh hospital details
      dispatch(getHospitalById(hospitalId));
    };

    handleDeactivation();
  }, [
    activateOrDeactivateSuccess,
    activateOrDeactivateError,
    toggle,
    productId,
    action,
    hospitalId,
    dispatch,
  ]);

  const TblBodyProductPlan = () => {
    return (
      <TableBody>
        {productAndPlanInfo?.map((item: any, index: any) => {
          const validityEnd = new Date(item?.planInfo?.validityEnd);
          return (
            <TableRow key={index}>
              <TableCell
                style={{
                  ...styles,
                  minWidth: "80px",
                  maxWidth: "80px",
                  textAlign: "center",
                  left: "0px",
                }}
              >
                <ActionTooltip
                  content={
                    <div
                      className="bg-white absolute left-[-12px] bottom-[-40px] mt-1 ms-12 border z-30 flex flex-col shadow-lg rounded-lg whitespace-nowrap"
                      ref={insideClickRef}
                    >
                      {validityEnd < currentDate &&
                        item?.planInfo?.planType === "per_annum" && decodeToken?.Roles !== "Admin" ? (
                        <button
                          type="button"
                          className="p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-t-lg rounded-b-lg"
                          onClick={() => editHospitalFn()}
                        >
                          Renew
                        </button>
                      ) : (
                        <>
                          {item?.planInfo?.isActive === 1 && (
                            <button
                              type="button"
                              className="p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold  rounded-t-lg"
                              onClick={() => editHospitalFn()}
                            >
                              Edit
                            </button>
                          )}

                          {item?.planInfo?.isActive === 1 && decodeToken?.Roles !== "Admin" && (
                            <button
                              type="button"
                              className={`p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-b-lg ${validityEnd > currentDate && ""
                                } `}
                              onClick={() =>
                                hospitalActiveDeactivateFn(
                                  item?.productInfo?.productId,
                                  "Deactivate"
                                )
                              }
                            >
                              {activateOrDeactivateLoading ? (
                                <LoadingSpinner width="w-4" height="h-4" />
                              ) : (
                                "Deactivate"
                              )}
                            </button>
                          )}
                          {item?.planInfo?.isActive === 0 && (
                            <>
                              <button
                                type="button"
                                className={`p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-t-lg ${validityEnd > currentDate && ""
                                  } `}
                                onClick={() => editHospitalFn()}
                              >
                                Edit
                              </button>{" "}
                              {decodeToken?.Roles !== "Admin" && <button
                                type="button"
                                className={`p-3 px-5 text-start text-secondary bg-white hover:text-primary hover:bg-blue-200 font-medium hover:font-semibold rounded-b-lg ${validityEnd > currentDate && ""
                                  } `}
                                onClick={() =>
                                  hospitalActiveDeactivateFn(
                                    item?.productInfo?.productId,
                                    "Activate"
                                  )
                                }
                              >
                                Reactivate
                              </button>}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  }
                >
                  <button
                    className="text-blue-300 w-[24px] h-[24px]"
                    type="button"
                    onClick={() => toogle(index)}
                    ref={onClickRef}
                  >
                    <MoreVertIcon />
                  </button>
                </ActionTooltip>
              </TableCell>
              <TableCell style={{ ...styles, minWidth: "250px" }}>
                {item?.productInfo?.name ? item?.productInfo?.name : "-"}
              </TableCell>
              <TableCell style={{ ...styles, minWidth: "200px" }}>
                {item?.addOnServices?.length <= 0 && "-"}
                {item?.addOnServices?.map((ser: any, index: any) => {
                  return (
                    <span key={index}>
                      {ser?.serviceName}
                      {index !== item.addOnServices.length - 1 && ", "}
                    </span>
                  );
                })}
              </TableCell>
              <TableCell style={styles}>
                {item?.planInfo?.serviceType
                  ? removeUnderScore(item?.planInfo?.serviceType)
                  : "-"}
              </TableCell>
              <TableCell style={styles}>
                {item?.planInfo?.planType
                  ? removeUnderScore(item?.planInfo?.planType)
                  : "-"}
              </TableCell>
              <TableCell style={styles}>
                {item?.planInfo?.patientType === "all"
                  ? item?.planInfo?.planTotalAmount === 0
                    ? "Free"
                    : formatIndianRupee(item?.planInfo?.planTotalAmount)
                  : item?.planInfo?.patientType === "in_patient"
                    ? item?.planInfo?.inPatientAmount === 0
                      ? "Free"
                      : formatIndianRupee(item?.planInfo?.inPatientAmount)
                    : item?.planInfo?.patientType === "out_patient"
                      ? item?.planInfo?.outPatientAmount === 0
                        ? "Free"
                        : formatIndianRupee(item?.planInfo?.outPatientAmount)
                      : "Free"}
              </TableCell>
              <TableCell style={{ ...styles, minWidth: "320px" }}>
                <div className="flex gap-3 items-center whitespace-nowrap">
                  {item?.planInfo?.planType !== "per_annum" ? (
                    "NA"
                  ) : (
                    <>
                      <DateProgressBar
                        validityStart={item?.planInfo?.validityStart}
                        validityEnd={item?.planInfo?.validityEnd}
                      />
                      <span>
                        Exp. Date:
                        <span className="text-primary font-semibold">
                          {moment(item?.planInfo?.validityEnd).format(
                            "DD MMM YYYY"
                          )}
                        </span>
                      </span>
                    </>
                  )}
                </div>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    );
  };

  return (
    <>
      <ConfirmationModal
        isVisible={isShowModal}
        onClose={() => {
          setIsShowModal(false);
        }}
        onClick={() => {
          activateOrDeactivateFn();
        }}
        icon={DeleteIcon}
        title={`Are you sure you want to ${action} this plan?`}
        description=""
        actionText={action}
        isLoading={activateOrDeactivateLoading}
      />
      <div className="mt-4">
        <span className="text-20 text-primary font-semibold">
          Product and Plan
        </span>
        <div className="pt-3">
          <DynamicTable
            columnData={columnHeader}
            children={<TblBodyProductPlan />}
            pagination={false}
          />
        </div>
      </div>
      <Grid container spacing={4} mb={4} mt={1}>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "25px",
          }}
        >
          <div>
            <span className="text-20 font-[600] text-primary">
              Patient Type
            </span>
          </div>

          {/* <DataRangeSelector
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            py="py-[8px]"
            border="border-gray-300"
            borderRadius="rounded-lg"
            shadow
            position="right-0"
          /> */}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <InPatientOccupied
            // fromDate={fromDate}
            // toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            title="In-Patients (IP)"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <InPatientOccupied
            // fromDate={fromDate}
            // toDate={toDate}
            title="Out-Patients (OP)"
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
          />
        </Grid>
      </Grid>
      <Grid container spacing={4} mb={4}>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "25px",
          }}
        >
          <div>
            <span className="text-20 font-[600] text-primary">
              Occupancy Details
            </span>
          </div>


        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <OccpancyCharts
            fromDate={fromDate}
            toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            title="ICU Beds"
            bedType="ICU"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <OccpancyCharts
            fromDate={fromDate}
            toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            title="Ward Beds"
            bedType="Ward"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <OccpancyCharts
            fromDate={fromDate}
            toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            title="OT Tables"
            bedType="OT"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <EquipmentDetailsChart />
        </Grid>
      </Grid>


      <Grid container spacing={4} mb={4}>

        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            paddingTop: "25px",
          }}
        >
          <div>
            <span className="text-20 font-[600] text-primary">
              Patient Details
            </span>
          </div>

          <DataRangeSelector
            fromDate={fromDate}
            setFromDate={setFromDate}
            toDate={toDate}
            setToDate={setToDate}
            py="py-[8px]"
            border="border-gray-300"
            borderRadius="rounded-lg"
            shadow
            position="right-0"
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <Departments
            fromDate={fromDate}
            toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            hospitalId={hospitalId}
          />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={6}
          style={{ paddingTop: "25px" }}
          sx={(theme) => ({
            display: "flex",
            height: {
              xs: "350px",
              sm: "400px",
              md: "400px",
              lg: "400px",
              xl: "450px",
              ...CustomHeight(theme),
            },
          })}
        >
          <Diagnosis
            fromDate={fromDate}
            toDate={toDate}
            country={country}
            state={state}
            district={district}
            taluk={taluk}
            hobli={hobli}
            serviceType={serviceType}
            filterApplyToggle={filterApplyToggle}
            hospitalId={hospitalId}

          />
        </Grid>
      </Grid>
    </>
  );
};

export default HospitalDashBoardTab;

const columnHeader = [
  {
    label: "Action",
    value: "action",
    sort: false,
    search: false,
  },
  {
    label: "Products",
    value: "products",
    sort: false,
    search: false,
  },
  {
    label: "Add-on Services",
    value: "add_on_services",
    sort: false,
    search: false,
  },
  {
    label: "Service Type",
    value: "service_type",
    sort: false,
    search: false,
  },
  {
    label: "Plan Type",
    value: "plan_type",
    sort: false,
    search: false,
  },
  {
    label: "Price",
    value: "price",
    sort: false,
    search: false,
  },
  {
    label: "Plan Validity",
    value: "plan_validity",
    sort: false,
    search: false,
  },
];
